import { useContext } from "react"
import { languageContext } from "../context/LanguageProvider"
import { languageCodes } from '../utils/langUtils';


export default function LanguageSwitcher({className}){
    const {language, changeLanguage} = useContext(languageContext)

    return(
        <div>
            <label htmlFor="lan" className="mr-3 text-xl font-medium">Please select language:</label>
            <select id ="lan" value={language} onChange={(e)=> changeLanguage(e.target.value)} className={className}>
                {Object.entries(languageCodes).map(([name, code])=>(
                    <option key={code} value={code}> {name.charAt(0).toUpperCase() + name.slice(1)}</option>
                ))}
            </select>
        </div>
    )
}